import Header from "../../common/header/DefaultHeader";
import SidebarMenu from "../../common/header/dashboard/SidebarMenu";
import MobileMenu from "../../common/header/MobileMenu";
import { getWebCMS } from "@/api/PDP";
import { useState, useEffect } from 'react'
import Footer from "../../common/footer/Footer";
import OtherLinkFooter from "@/components/common/footer/OtherLinkFooter";
import NewFooter from "@/components/common/footer/NewFooter";

const index = () => {
  const [webCMS, setWebCMS] = useState(null);
  useEffect(() => {
    getWebCMS("pages/userDashboard").then((response) => {
      setWebCMS(response?.results[0]);
    })
  }, []);
  const user = JSON.parse(localStorage.getItem('user'))
  return (
    <>
      {/* <!-- Main Header Nav --> */}
      <Header />

      {/* <!--  Mobile Menu --> */}
      <MobileMenu />

      <div className="dashboard_sidebar_menu">
        <div
          className="offcanvas offcanvas-dashboard offcanvas-start"
          tabIndex="-1"
          id="DashboardOffcanvasMenu"
          data-bs-scroll="true"
        >
          <SidebarMenu />
        </div>
      </div>
      {/* End sidebar_menu */}

      {/* <!-- Our Dashbord --> */}
      <section className="our-dashbord dashbord bgc-f7 pb50">
        <div className="container-fluid ovh">
          <div className="row">
            <div className="col-lg-12 maxw100flex-992">
              <div className="row">
                {/* Start Dashboard Navigation */}
                <div className="col-lg-12">
                  <div className="dashboard_navigationbar dn db-1024">
                    <div className="dropdown">
                      <button
                        className="dropbtn"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#DashboardOffcanvasMenu"
                        aria-controls="DashboardOffcanvasMenu"
                      >
                        <i className="fa fa-bars pr10"></i> Dashboard Navigation
                      </button>
                    </div>
                  </div>
                </div>
                {/* End Dashboard Navigation */}

                <div className="col-lg-12 mb10">
                  <div className="breadcrumb_content style2">
                    <h1>Welcome, {user?.firstName} {user?.lastName}</h1>
                    {/* <h2 className="breadcrumb_title">Howdy, Hasan</h2> */}
                    <p>{webCMS?.dashboard?.greetingMessage}</p>
                  </div>
                </div>
              </div>
              {/* End .row */}

            </div>
            {/* End .col */}
          </div>
        </div>
      </section>
 <div className="container-fluid px-0">
                      {/* <Footer /> */}
                      <OtherLinkFooter />
                      <NewFooter />
                    </div>
      
    </>
  );
};

export default index;
